export default {
  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   */
  set(name, value, days) {
    let expires = '';

    const HOURS_DAY = 24;
    const MINUTES_HOUR = 60;
    const SECONDS_MINUTE = 60;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * HOURS_DAY * MINUTES_HOUR * SECONDS_MINUTE * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },
};
